import referenceTableDeletedProjections from './projection/reference-table-deleted.projection';
import referenceTableNameSetProjections from './projection/reference-table-name-set.projection';
import referenceTableDescriptionSetProjections from './projection/reference-table-description-set.projection';
import referenceTableItemDeletedProjections from './projection/reference-table-item-deleted.projection';
import referenceTableInitializedProjections from './projection/reference-table-initialized.projection';
import referenceTableItemAddedProjections from './projection/reference-table-item-added.projection';
import referenceTableItemAttributesReplacedProjections from './projection/reference-table-item-attributes-replaced.projection';
const projections = {
    ...referenceTableInitializedProjections,
    ...referenceTableDeletedProjections,
    ...referenceTableNameSetProjections,
    ...referenceTableDescriptionSetProjections,
    ...referenceTableItemDeletedProjections,
    ...referenceTableItemAddedProjections,
    ...referenceTableItemAttributesReplacedProjections,
};
export default projections;
//# sourceMappingURL=projections-index.js.map